<template>
  <div class="container">
    <div class="container">
      <span>{{ i18n.global.t("relogintoast.SoonLoggedOut").replace("[TIME]", Math.floor(props.timeToLogout)) }}</span><br>
    </div>
    <div class="btnContainer">
      <div class="btnContainer2">
        <MainButton :button-text="i18n.global.t(`relogintoast.Yes`)"
                    @button-clicked="reloginClick"
        />
      </div>
      <div class="btnContainer2">
        <MainButton :button-text="i18n.global.t(`relogintoast.No`)"
                    @button-clicked="close()"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import i18n from '@/locales/i18n'
import { defineProps, defineEmits } from 'vue'
import MainButton from '@/components/buttons/MainButton.vue'

const emit = defineEmits(['reloginClick'])

const props = defineProps({
  timeToLogout: {
    type: String,
    default () {
      return ''
    }
  }
})

function close () {
  // eslint-disable-next-line vue/require-explicit-emits
  emit('close-toast')
}

function reloginClick () {
  // eslint-disable-next-line vue/require-explicit-emits
  emit('close-toast')
  emit('reloginClick')
}

</script>

<style lang="scss" scoped>

.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.btnContainer{
  display: flex;
  flex-direction: row;
  justify-content:space-evenly;
  align-items: center;
  margin-top:0.5rem;
  height:3rem;
  width: 100%;
}
.btnContainer2{
  height: 100%;
  width: 80px;
}
</style>
